import * as React from 'react'
import ExpandIcon from '../../../icons/ui/ExpandIcon'
import CollapseIcon from '../../../icons/ui/CollapseIcon'
import { Link, Route, BrowserRouter, RouteComponentProps } from 'react-router-dom'
import Map from './Map'
import DrawingToolsButtons from './DrawingToolsButtons'
import ServiceZones from './ServiceZones'
import { IGoinZoneObject, IMap, IZoneObject } from '../../../../types'
import { GoinZoneType, GoinZoneShapeType } from '../../../../types'
import GoinZonesListItem from './GoinZonesListItem'
import RemoveZoneModal from './RemoveZoneModal'
import tj from '@mapbox/togeojson'
import { withNotification } from '../../../ui/notification-provider'
import ErrorBar from 'src/components/ui/ErrorBar'

interface IGoinZonesPaneState {
  expanded: { [key: string]: boolean }
  enablePriceAddServiceZone: boolean
  adding: boolean
  toAdd: GoinZoneType
  isSaving: false
  color: string
  showPallete: boolean
  map: any
  specificErrorMsg: string
  drawBy: DrawingMode
  address: string
  buffer: any[]
  toEdit: IGoinZoneObject | null
  notification?: any
  zones: { [key: string]: IGoinZoneObject } // temporary placement for zones until this view (create new service) is finished
  selectedZoneForHotspot: IGoinZoneObject | null
  error: IError
}

interface IGoinZonesPaneProps extends RouteComponentProps {
  showMessage: (message: string, isError: boolean) => void
  addGoinZone: (goinzone: IGoinZoneObject, orgId: string, serviceId: string) => Promise<any>
  addGoinZoneHotspot: (goinzone: IGoinZoneObject, orgId: string, serviceId: string) => Promise<any>
  getGoinzones: (orgId: string, serviceId: string) => Promise<any>
  removeGoinZone: (id: string, orgId: string, serviceId: string) => Promise<any>
  updateGoinZone: (goinzone: IGoinZoneObject, orgId: string, serviceId: string) => Promise<any>
  enableButtons: (flag: boolean) => Promise<any>
  orgId: string
  serviceId: string
  zones: { [key: string]: IZoneObject }
  viewMode?: boolean
  notification: any
  designatedHotspotsEnabled?: number
}

interface IError {
  message: string
  updatedAt: number
}

const COLOR_PALLETE: string[] = [
  '#D67576',
  '#860A4E',
  '#E44C11',
  '#F8A631',
  '#FFD425',
  '#81761F',
  '#588A33',
  '#16703A',
  '#00599A',
  '#16277C',
  '#643EB5',
  '#C0105B',
  '#FD4D54',
  '#F47817',
  '#FBBE39',
  '#FFE828',
  '#B0B334',
  '#7FB247',
  '#1198A6',
  '#028AD0',
  '#364CA9',
  '#992BAE',
  '#4D342F',
  '#785448',
  '#FFFFFF',
  '#BDBDBD',
  '#757575',
  '#424242',
  '#000000'
]

const RESET_ERROR: IError = {
  message: '',
  updatedAt: Date.now()
}

export enum DrawingMode {
  ZONE = 'zone',
  PLACE = 'place',
  CITY = 'city',
  COUNTY = 'county',
  STATE = 'state',
  KMLFILE = 'kml-file'
}

class GoinZonesPane extends React.Component<IGoinZonesPaneProps, IGoinZonesPaneState> {
  constructor(props: IGoinZonesPaneProps) {
    super(props)
    this.state = {
      isSaving: false,
      adding: false,
      buffer: [],
      zones: {},
      toEdit: null,
      enablePriceAddServiceZone: true,
      specificErrorMsg: '',
      toAdd: GoinZoneType.SERVICE_ZONE,
      address: '',
      map: null,
      showPallete: false,
      color: '#000000',
      drawBy: DrawingMode.ZONE,
      expanded: {
        'service zones': true,
        'restricted zones': true,
        'pick up/drop off point': true
      },
      selectedZoneForHotspot: null,
      error: RESET_ERROR
    }
  }

  public componentDidMount() {
    console.log('Props Her', this.props)

    this.fetchGoinZones()
  }

  public componentDidUpdate(
    prevProps: Readonly<IGoinZonesPaneProps>,
    prevState: Readonly<IGoinZonesPaneState>,
    snapshot?: any
  ): void {
    if (prevState.error.message !== this.state.error.message) {
      this.setState({
        error: RESET_ERROR
      })
    }
  }

  public componentDidCatch() {
    console.log('error catch')
  }

  public fetchGoinZones() {
    return new Promise<void>((approve, reject) => {
      this.props.getGoinzones(this.props.orgId, this.props.serviceId).then(() => {
        const zones: { [key: string]: IGoinZoneObject } = {}
        for (const zoneId of Object.keys(this.props.zones)) {
          if (this.props.zones[zoneId].center) {
            zones[zoneId] = this.convertIZoneToIGoinZone(this.props.zones[zoneId])
          }
        }

        for (const i of Object.keys(zones)) {
          if (zones[i].coordinates) {
            const coors = zones[i].coordinates
            zones[i].coordinates = { lng: coors.lng, lat: coors.lat }
            this.centerTo(zones[i].coordinates)
          }
          zones[i] = { ...zones[i], visible: true }
        }
        this.setState(
          {
            zones
          },
          () => {
            approve()
            this.refreshZones()
          }
        )
      })
    })
  }

  public render() {
    const listStyle: any = {
      pointerEvents: this.state.adding ? 'none' : 'auto',
      opacity: this.state.adding ? 0.4 : 1.0
    }
    const mapInnerStyle: any = {
      zIndex: -1,
      display: 'block',
      width: '100%',
      height: '500px'
    }
    const getRemoveZoneModal = (props: any) => {
      return (
        <div>
          <RemoveZoneModal
            {...props}
            onClose={this.props.history.goBack}
            zones={this.state.zones}
            onRemove={this.onRemoveZone}
          />
        </div>
      )
    }

    return (
      <section className='flex'>
        <Route path={`${this.props.match.path}/remove-zone/:id`} component={getRemoveZoneModal} />

        {this.state.error.message && this.errorNotification(this.state.error)}

        {/* LEFT BAR */}
        <div className='flex' style={{ flex: 0.3, overflowY: 'scroll', overflowX: 'auto' }}>
          <div style={{ width: '100%' }}>
            {/* ADDING */}
            {this.state.adding && (
              <div style={{ width: '100%' }} className='mt3'>
                <div className='pl3 pr3'>
                  {/* DRAWING TOOLS BUTTONS */}
                  <DrawingToolsButtons
                    onDrawingToolSelect={this.onDrawingToolSelect}
                    drawBy={this.state.drawBy}
                    map={this.state.map}
                    toAdd={this.state.toAdd}
                    adding={this.state.adding}
                    address={this.state.address}
                    onLocationAutocompleteChange={this.onLocationAutocompleteChange}
                    onLocationAutocompleteDropdownSelect={this.onLocationAutocompleteDropdownSelect}
                    loadKmlFile={this.loadKmlFile}
                  />
                  {/* Service Zones */}
                  <ServiceZones
                    color={this.state.color}
                    onCancel={this.onCancel}
                    onClickColorPick={this.onClickColorPick}
                    buffer={this.state.buffer}
                    getColorPallete={this.getColorPallete}
                    showSpecificError={this.showSpecificError}
                    showPallete={this.state.showPallete}
                    specificErrorMsg={this.state.specificErrorMsg}
                    onAddServiceZone={this.onAddServiceZone}
                    showMessage={this.props.showMessage}
                    toEdit={this.state.toEdit}
                    selectedZoneForHotspot={this.state.selectedZoneForHotspot}
                  />
                </div>
              </div>
            )}
            {/* SHOW LIST */}
            {!this.state.adding && (
              <div style={listStyle} className='ml3 mt3 mr3'>
                {this.getLists()}
              </div>
            )}
          </div>
        </div>
        {/* MAP */}
        <div className='mt1' style={{ flex: 0.7 }}>
          <div style={mapInnerStyle}>
            <Map
              onAddedShape={this.addBuffer}
              onMapMounted={this.onMapMounted}
              enableDrawingManager={this.state.adding && this.state.drawBy === DrawingMode.ZONE}
              color={this.state.color}
            />
          </div>
        </div>
      </section>
    )
  }

  private convertIZoneToIGoinZone = (zone: IZoneObject): IGoinZoneObject => {
    return {
      id: zone.id || '',
      geojson: zone.shape ? zone.shape.coordinates : null,
      coordinates: zone.center
        ? {
            lat: zone.center.coordinates[1],
            lng: zone.center.coordinates[0]
          }
        : {
            lat: 0,
            lng: 0
          },
      radius: zone.radius || 0,
      name: zone.name,
      address: zone.address || '',
      description: zone.description || '',
      price: 0,
      type: zone.shapeType,
      zoneType: zone.type,
      color: zone.color,
      mapObject: null,
      pointType: '',
      visible: false
    }
  }

  private onMapMounted = (map: any) => {
    this.setState({
      map
    })
  }

  private addBuffer = (p: any) => {
    this.clearBuffer()
    const buffer = Object.assign([], this.state.buffer)
    if (p.mapObject.setEditable) {
      p.mapObject.setEditable(true)
    }
    buffer.push(p)
    this.setState({
      buffer
    })
  }

  private centerTo = (center: any, zoom: number = 10) => {
    if (!this.state.map) {
      return
    }
    this.state.map.setCenter(center)
    this.state.map.setZoom(zoom)
  }

  private showSpecificError = (msg: string) => {
    this.props.showMessage(msg, true)
    this.setState({
      specificErrorMsg: msg
    })
  }

  private clearBuffer = () => {
    let buffer = Object.assign([], this.state.buffer)
    for (const i of Object.keys(buffer)) {
      buffer[i].mapObject.setMap(null)
    }
    buffer = []
    this.setState({
      buffer
    })
  }

  private loadKmlFile = (file: any) => {
    const reader = new FileReader()
    const self = this
    self.clearBuffer()
    reader.addEventListener('load', () => {
      const kml = new DOMParser().parseFromString(reader.result + '', 'text/xml')
      const convertedWithStyles = tj.kml(kml, { styles: true })

      const centerPoint = {
        lat: 0,
        lng: 0
      }
      if (typeof convertedWithStyles.features[0].geometry.coordinates[0] === 'object') {
        convertedWithStyles.features[0].geometry.coordinates[0].map((p: any) => {
          centerPoint.lat += p[1]
          centerPoint.lng += p[0]
        })

        centerPoint.lat /= convertedWithStyles.features[0].geometry.coordinates[0].length
        centerPoint.lng /= convertedWithStyles.features[0].geometry.coordinates[0].length

        const data = new google.maps.Data()
        data.setStyle({
          draggable: true,
          editable: true,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          strokeColor: self.state.color,
          // fillColor: self.state.color,
          fillOpacity: 0
        })
        data.addGeoJson(convertedWithStyles)
        data.setMap(self.state.map)
        self.addBuffer({
          mapObject: data,
          innerType: GoinZoneShapeType.SHAPE_MULTIPOLYGON,
          center: { lat: Number(centerPoint.lat), lng: Number(centerPoint.lng) }
        })
        self.state.map.setCenter({
          lat: Number(centerPoint.lat),
          lng: Number(centerPoint.lng)
        })
      } else {
        this.props.notification.addNotification({
          title: 'KML file is not valid please try with some other file',
          level: 'error'
        })
      }
    })
    reader.readAsText(file)
  }

  private fetchPolygon = (q: string) => {
    return new Promise((resolve, reject) => {
      fetch(encodeURI('https://nominatim.openstreetmap.org/search?q=' + q + '&polygon_geojson=1&format=json'))
        .then(response => {
          resolve(response.json())
        })
        .catch(result => {
          console.log('Failed to fetch polygon from openstreetmap: ' + result)
          this.props.showMessage('Failed to fetch polygon from openstreetmap: ' + result, true)
          reject(result)
        })
    })
  }

  private onLocationAutocompleteChange = (address: any) => {
    this.setState({ address })
  }

  private onAddPoint = (center: any, name: string, pointType: string) => {
    this.clearBuffer()
    const marker = new google.maps.Marker({
      position: center,
      map: this.state.map,
      title: name,
      icon: this.getPinSymbol(pointType === 'pickup' ? '#37c47e' : '#ff5c47')
    })
    this.addBuffer({
      mapObject: marker,
      innerType: GoinZoneShapeType.SHAPE_POINT,
      center: Object.assign({}, center)
    })
  }

  private onLocationAutocompleteDropdownSelect = (address: any) => {
    this.fetchPolygon(address).then(
      (json: any) => {
        this.clearBuffer()
        const first = json[0]
        if (!first || !first.geojson) {
          // TODO: throw error
          console.log("Unable to find '" + address + "'")
          this.props.showMessage("Unable to find '" + address + "'", true)
          return
        }
        this.state.map.setCenter({
          lat: Number(first.lat),
          lng: Number(first.lon)
        })
        const coors = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: Object.assign({}, first.geojson)
            }
          ]
        }
        const data = new google.maps.Data()
        data.setStyle({
          strokeOpacity: 0.8,
          strokeWeight: 2,
          strokeColor: this.state.color,
          // fillColor: this.state.color,
          fillOpacity: 0
        })
        data.addGeoJson(coors)
        data.setMap(this.state.map)
        this.addBuffer({
          mapObject: data,
          innerType: GoinZoneShapeType.SHAPE_MULTIPOLYGON,
          center: { lat: Number(first.lat), lng: Number(first.lon) }
        })
      },
      err => {
        // TODO: Handle error calling this service
        return
      }
    )
  }

  private setZoneVisible = (zone: IGoinZoneObject, visible: boolean) => {
    const zones = Object.assign({}, this.state.zones)

    if (visible) {
      this.centerTo(zones[zone.id].coordinates)
    }

    zones[zone.id].visible = visible
    this.setState(
      {
        zones
      },
      () => {
        this.refreshZones()
      }
    )
  }

  private onEditZone = (zone: IGoinZoneObject) => {
    const zones = Object.assign({}, this.state.zones)
    Object.keys(zones).map(zid => {
      zones[zid].visible = false
    })
    zones[zone.id].visible = false
    this.centerTo(zone.coordinates)
    this.setState(
      {
        error: RESET_ERROR,
        toAdd: zone.zoneType,
        adding: true,
        toEdit: zone,
        color: zone.color,
        drawBy: zone.type === GoinZoneShapeType.SHAPE_MULTIPOLYGON ? DrawingMode.STATE : DrawingMode.ZONE,
        zones
      },
      () => {
        this.addBuffer({
          mapObject: this.buildOnMap(zone, this.state.map, false),
          innerType: zone.type,
          center: Object.assign({}, zone.coordinates)
        })
        this.refreshZones()
      }
    )
    return new Promise<void>((resolve, reject) => {
      resolve()
    })
  }

  private onDrawingToolSelect = (tool: DrawingMode) => {
    this.setState({
      drawBy: tool,
      address: ''
    })
  }

  private onClickColorPick = () => {
    this.setState({
      showPallete: true
    })
  }

  private getColorPallete = () => {
    const onColorChoose = (color: string) => {
      this.setState({
        showPallete: false,
        color
      })
      for (const c of Object.keys(this.state.buffer)) {
        const buff: any = this.state.buffer[c]
        if (buff.setStyle) {
          buff.setStyle({
            strokeOpacity: 0.8,
            strokeWeight: 2,
            strokeColor: color,
            // fillColor: color,
            fillOpacity: 0
          })
        }
      }
    }
    const colors: any = []
    for (const i of Object.keys(COLOR_PALLETE)) {
      const onClick = () => {
        onColorChoose(COLOR_PALLETE[i])
      }
      const style = {
        margin: '1px',
        display: 'inline-block',
        width: '24px',
        height: '24px',
        backgroundColor: COLOR_PALLETE[i],
        cursor: 'pointer'
      }
      colors.push(
        <div onClick={onClick} key={i} className='rounded' style={style}>
          &nbsp;
        </div>
      )
    }
    return (
      <div style={{ maxWidth: '286px' }} className='block mt1'>
        {colors}
      </div>
    )
  }

  private onCancel = () => {
    this.props.showMessage('', false)
    this.props.enableButtons(false)
    const zones = Object.assign({}, this.state.zones)
    if (this.state.toEdit != null) {
      zones[this.state.toEdit.id].visible = true
    }
    Object.keys(zones).forEach(zid => {
      zones[zid].visible = true
    })
    this.clearBuffer()
    this.setState(
      {
        toAdd: GoinZoneType.SERVICE_ZONE,
        adding: false,
        toEdit: null,
        zones,
        selectedZoneForHotspot: null
      },
      () => {
        this.refreshZones()
      }
    )
  }

  private onAddServiceZoneAddButton = () => {
    this.props.enableButtons(true)
    const zones = Object.assign({}, this.state.zones)
    Object.keys(zones).forEach(zid => {
      zones[zid].visible = false
    })
    this.clearBuffer()
    this.clearMap()
    this.setState(
      {
        zones,
        adding: true,
        error: RESET_ERROR
      },
      () => {
        this.props.showMessage('', false)
      }
    )
  }

  private errorNotification = (error: IError) => <ErrorBar error={error} />

  private onAddServiceZoneHotspotAddButton = (zone: IGoinZoneObject) => {
    if (!this.props.designatedHotspotsEnabled) {
      this.setState({
        error: {
          message: 'Designated hotspots is disabled for this service.',
          updatedAt: Date.now()
        }
      })
      return
    }

    this.props.enableButtons(true)
    const zones = Object.assign({}, this.state.zones)
    Object.keys(zones).forEach(zid => {
      zones[zid].visible = false
    })
    this.clearBuffer()
    this.clearMap()
    this.setState(
      {
        zones,
        adding: true,
        selectedZoneForHotspot: zone
      },
      () => {
        this.props.showMessage('', false)
      }
    )
    return new Promise<void>((resolve, reject) => {
      resolve()
    })
  }

  private clearMap = () => {
    for (const i of Object.keys(this.state.zones)) {
      this.state.zones[i].visible = false
      if (this.state.zones[i].mapObject) {
        this.state.zones[i].mapObject.setMap(null)
      }
    }
  }

  private onAddServiceZone = (values: any) => {
    this.props.showMessage('', false)

    return new Promise<void>((resolve, reject) => {
      const proxy: any = this.state.buffer[0]
      // multipolygon
      if (this.state.drawBy !== DrawingMode.ZONE) {
        proxy.mapObject.toGeoJson((feature: any) => {
          const id = values.original ? values.original.id : Math.round(Math.random() * 1500)
          const zone: IGoinZoneObject = {
            id,
            name: values.zoneTitle,
            color: this.state.color,
            description: values.description,
            price: values.price,
            address: '',
            radius: 0,
            coordinates: {
              lng: proxy.center.lng,
              lat: proxy.center.lat
            },
            visible: false,
            type: feature.features[0].geometry.type,
            zoneType: values.zoneType,
            geojson: feature.features[0].geometry.coordinates,
            mapObject: null,
            pointType: '',
            zoneId: this.state.selectedZoneForHotspot ? this.state.selectedZoneForHotspot.id : undefined
          }
          proxy.mapObject.setMap(null)
          const zones = Object.assign({}, this.state.zones)
          Object.keys(zones).map(zid => {
            zones[zid].visible = false
          })
          const method = this.state.selectedZoneForHotspot
            ? this.addGoinZoneHotspot
            : values.original
            ? this.updateGoinZone
            : this.addGoinZone // update or create new one?

          method(zone).then(() => {
            zones[id] = zone
            this.setState(
              {
                adding: false,
                zones,
                toEdit: null
              },
              () => {
                this.clearBuffer()
                this.refreshZones()
                resolve()
                this.props.showMessage('Saved Service zone succesfully', false)
                this.props.enableButtons(false)
              }
            )
          })
        })
        // circle or drawn polygon
      } else {
        let geojson: any = null
        const center = {
          lat: 0,
          lng: 0
        }
        if (proxy.innerType === GoinZoneShapeType.SHAPE_POLYGON) {
          geojson = []
          let count = 0
          for (const point of proxy.mapObject.getPath().getArray()) {
            geojson.push([point.lng(), point.lat()])
            center.lat += point.lat()
            center.lng += point.lng()
            count++
          }
          geojson.push(geojson[0])
          center.lat /= count
          center.lng /= count
          geojson = [geojson]
        }

        const id = values.original ? values.original.id : Math.round(Math.random() * 1500)
        const zone: IGoinZoneObject = {
          id,
          name: values.zoneTitle,
          color: this.state.color,

          description: values.description,
          zoneType: values.zoneType,
          price: values.price,
          address: '',
          visible: false,
          coordinates:
            proxy.innerType === GoinZoneShapeType.SHAPE_CIRCLE
              ? {
                  lng: proxy.mapObject.getCenter().lng(),
                  lat: proxy.mapObject.getCenter().lat()
                }
              : center,
          radius: proxy.innerType === GoinZoneShapeType.SHAPE_CIRCLE ? proxy.mapObject.getRadius() : 0,
          type: proxy.innerType,
          geojson,
          mapObject: null,
          pointType: '',
          zoneId: this.state.selectedZoneForHotspot ? this.state.selectedZoneForHotspot.id : undefined
        }
        proxy.mapObject.setMap(null)
        const zones = Object.assign({}, this.state.zones)
        const method = this.state.selectedZoneForHotspot
          ? this.addGoinZoneHotspot
          : values.original
          ? this.updateGoinZone
          : this.addGoinZone // update or create new one?
        Object.keys(zones).map(zid => {
          zones[zid].visible = false
        })
        method(zone).then(() => {
          zones[id] = zone
          this.setState(
            {
              adding: false,
              zones,
              toEdit: null
            },
            () => {
              this.clearBuffer()
              this.refreshZones()
              resolve()
              this.props.showMessage('Saved Service zone succesfully', false)
            }
          )
        })
      }
      return
    })
  }

  private updateGoinZone = (goinzone: IGoinZoneObject) => {
    this.clearMap()
    return this.props.updateGoinZone(goinzone, this.props.orgId, this.props.serviceId).then(() => {
      this.fetchGoinZones()
    })
  }

  private addGoinZone = (goinzone: IGoinZoneObject) => {
    this.clearMap()
    return this.props.addGoinZone(goinzone, this.props.orgId, this.props.serviceId).then(() => {
      this.fetchGoinZones()
    })
  }

  private addGoinZoneHotspot = (goinzone: IGoinZoneObject) => {
    this.clearMap()
    return this.props.addGoinZoneHotspot(goinzone, this.props.orgId, this.props.serviceId).then(() => {
      this.fetchGoinZones()
    })
  }

  private onRemoveZone = (zone: IGoinZoneObject) => {
    this.clearMap()
    return new Promise<void>((approve, reject) => {
      this.props.removeGoinZone(zone.id, this.props.orgId, this.props.serviceId).then(() => {
        this.fetchGoinZones()
        approve()
      })
    })
  }

  private getPinSymbol = (color: string) => {
    return {
      path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
      fillColor: color,
      fillOpacity: 1,
      strokeColor: '#000',
      strokeWeight: 2,
      scale: 1
    }
  }

  private buildOnMap = (zone: IGoinZoneObject, map: any, card: boolean = false) => {
    const me: any = this
    const buildCard = (zone: IGoinZoneObject) => {
      return (
        '<div id="content">' +
        '<div id="siteNotice">' +
        '</div>' +
        '<h1 id="firstHeading" class="firstHeading"><span style="display:block; width:16px; height:16px; backgroundColor:\'' +
        zone.color +
        '\';" />' +
        zone.name +
        '</h1>' +
        '<h3 id="firstHeading" class="firstHeading">' +
        zone.zoneType +
        '</h3>' +
        '<div id="bodyContent">' +
        '<p>' +
        zone.description +
        '</p>' +
        '</div>' +
        '</div>'
      )
    }

    const toMap: any | null = (zone: IGoinZoneObject) => {
      if (zone.type === GoinZoneShapeType.SHAPE_POINT) {
        const data = new google.maps.Marker({
          position: zone.coordinates,
          map,
          title: zone.name,
          icon: this.getPinSymbol(zone.pointType === 'pickup' ? '#37c47e' : '#ff5c47')
        })

        if (card) {
          const infowindow = new google.maps.InfoWindow({
            content: buildCard(zone),
            maxWidth: 200
          })

          data.addListener('click', () => {
            map.setCenter(data.getPosition())
            infowindow.open(map, data)
          })
        }

        return data
      }
      if (zone.type === GoinZoneShapeType.SHAPE_MULTIPOLYGON) {
        const coors = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'MultiPolygon',
                coordinates: zone.geojson
              }
            }
          ]
        }
        const data = new google.maps.Data()
        data.setStyle({
          draggable: !!this.state.toEdit,
          editable: !!this.state.toEdit,
          strokeOpacity: 1,
          strokeWeight: 2,
          strokeColor: zone.color,
          fillColor: '#FAFAFA',
          fillOpacity: 0.35
        })
        data.addGeoJson(coors)
        data.setMap(map)
        if (card) {
          const infowindow = new google.maps.InfoWindow({
            content: buildCard(zone),
            maxWidth: 200
          })

          data.addListener('click', () => {
            map.setCenter(zone.coordinates)
            infowindow.open(map)
            infowindow.setPosition(zone.coordinates)
          })
        }
        return data
      }
      if (zone.type === GoinZoneShapeType.SHAPE_CIRCLE) {
        const data = new google.maps.Circle({
          strokeOpacity: 1,
          strokeWeight: 2,
          strokeColor: zone.color,
          // fillColor: zone.color,
          fillOpacity: 0
        })
        data.setRadius(zone.radius)
        data.setCenter(zone.coordinates)
        data.setMap(map)
        if (card) {
          const infowindow = new google.maps.InfoWindow({
            content: buildCard(zone),
            maxWidth: 200
          })

          data.addListener('click', () => {
            map.setCenter(zone.coordinates)
            infowindow.open(map)
            infowindow.setPosition(zone.coordinates)
          })
        }
        return data
      }
      return null
    }

    return toMap(zone)
  }

  private refreshZones = () => {
    const me: any = this

    const zones = Object.assign({}, this.state.zones)
    for (const i of Object.keys(zones)) {
      const zone: IGoinZoneObject = zones[i]
      if (zone.mapObject) {
        zone.mapObject.setMap(null)
        zone.mapObject = null
      }
      if (!zone.visible) {
        continue
      }
      zone.mapObject = this.buildOnMap(zone, this.state.map, true)
    }
    this.setState({
      zones
    })
  }

  private getLists = () => {
    const getListByType = (type: GoinZoneType) => {
      const list: any[] = []
      for (const i of Object.keys(this.state.zones)) {
        const zone = this.state.zones[i]
        list.push(zone)
      }
      return (
        <div>
          <div className='zones-wrapper'>
            <ul>
              {Object.keys(list).map((item, i) => (
                <GoinZonesListItem
                  key={i}
                  centerTo={this.centerTo}
                  match={this.props.match}
                  onEditZone={this.onEditZone}
                  setZoneVisible={this.setZoneVisible}
                  map={this.state.map}
                  zone={list[item]}
                  viewMode={this.props.viewMode}
                  isAddingHotspot={this.onAddServiceZoneHotspotAddButton}
                />
              ))}
            </ul>
          </div>
        </div>
      )
    }

    return (
      <div>
        {!this.props.viewMode && (
          <div
            onClick={this.onAddServiceZoneAddButton}
            style={{ boxShadow: '0px 0px 2px grey' }}
            className='AddServiceZoneFloatingButton rounded btn bg-white font-blue-grey h5 mr1 ml1'
          >
            + Add Service Zone
          </div>
        )}
        <div className='mb1'>{getListByType(GoinZoneType.SERVICE_ZONE)}</div>
      </div>
    )
  }

  private getToggleArrow = (id: string) => {
    const onToggleExpand = () => {
      const expanded = Object.assign({}, this.state.expanded)
      expanded[id] = !expanded[id]
      this.setState(
        {
          expanded
        },
        () => {
          // this.props.showMessage('', false)
        }
      )
    }
    return (
      <span>
        {!this.state.expanded[id] && (
          <span style={{ cursor: 'pointer' }} onClick={onToggleExpand}>
            <ExpandIcon className='icon--small svg-stroke-grey3 mr1' />
          </span>
        )}
        {this.state.expanded[id] && (
          <span style={{ cursor: 'pointer' }} onClick={onToggleExpand}>
            <CollapseIcon className='icon--small svg-stroke-grey3 mr1' />
          </span>
        )}
      </span>
    )
  }
}

export default withNotification(GoinZonesPane)



// WEBPACK FOOTER //
// ./src/components/services/edit/goinzones/GoinZonesPane.tsx